import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";
import DocumentItem from "../../Components/Masters/DocumentItem";

const BusinessViewPage = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-IN") : "—";

  const fields = [
    {
      label: "Date of Travel",
      previous: formatDate(data?.dateOfTravel),
      requested: formatDate(data?.editValue?.dateOfTravel),
    },
    {
      label: "Employee Name",
      previous: data?.employeeName || "—",
      requested: data?.editValue?.employeeName || "—",
    },
    {
      label: "Employee Position",
      previous: data?.employeePosition || "—",
      requested: data?.editValue?.employeePosition || "—",
    },
    {
      label: "Travel Type",
      previous: data?.travelType || "—",
      requested: data?.editValue?.travelType || "—",
    },
    {
      label: "Travel Mode",
      previous: data?.travelMode || "—",
      requested: data?.editValue?.travelMode || "—",
    },
    // {
    //   label: "Transportation",
    //   previous: data?.transportation || "—",
    //   requested: data?.editValue?.transportation || "—",
    // },
    {
      label: "Origin",
      previous: data?.origin || "—",
      requested: data?.editValue?.origin || "—",
    },
    {
      label: "Destination",
      previous: data?.destination || "—",
      requested: data?.editValue?.destination || "—",
    },
    // {
    //   label: "Travel Duration",
    //   previous:
    //     data?.travelDuration?.value && data?.travelDuration?.unit
    //       ? `${data.travelDuration.value} ${data.travelDuration.unit}`
    //       : "—",
    //   requested:
    //     data?.editValue?.travelDuration?.value &&
    //     data?.editValue?.travelDuration?.unit
    //       ? `${data.editValue.travelDuration.value} ${data.editValue.travelDuration.unit}`
    //       : "—",
    // },
    // {
    //   label: "Distance Covered",
    //   previous:
    //     data?.distanceCovered?.value && data?.distanceCovered?.unit
    //       ? `${data.distanceCovered.value} ${data.distanceCovered.unit}`
    //       : "—",
    //   requested:
    //     data?.editValue?.distanceCovered?.value &&
    //     data?.editValue?.distanceCovered?.unit
    //       ? `${data.editValue.distanceCovered.value} ${data.editValue.distanceCovered.unit}`
    //       : "—",
    // },
    // {
    //   label: "Accommodation",
    //   previous: data?.accommodation || "—",
    //   requested: data?.editValue?.accommodation || "—",
    // },
    // {
    //   label: "Hotel Rating",
    //   previous: data?.hotelRating || "—",
    //   requested: data?.editValue?.hotelRating || "—",
    // },
    {
      label: "Number of Nights",
      previous: data?.numberOfNights || "—",
      requested: data?.editValue?.numberOfNights || "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Business Travel Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
      customDocumentRender={(url, i) => (
        <DocumentItem key={`doc-${i}`} url={url} />
      )}
    />
  );
};

export default BusinessViewPage;
